export const modes = {
  SELECT: 'SELECT',
  ITEM_DRAG: 'ITEM_DRAG',
  PAN: 'PAN',
  EDGE_DRAW: 'EDGE_DRAW',
  EDGE_CREATE: 'EDGE_CREATE',
  GROUPING_CREATE: 'GROUPING_CREATE',
  VERTEX_CREATE: 'VERTEX_CREATE',
};
